module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f3d64c8ef45a9a3e62da8eba711c8199.png";